<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='product-all-grid'>
      <dx-data-grid ref='refProductAllGrid'
        :data-source='rawMaterialInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="true"
        key-expr="품번"
        :focused-row-key.sync='focusedRowKey'
        @row-removed='onRowRemoved'
        @row-updated='onRowUpdated' @row-updating='onUpdating'
        @editor-preparing='onEditorPreparing' @content-ready='onContentReady'
        @init-new-row='onInitNewRow'
        @rowDblClick ='onRowDbClick'
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="productType"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="true"
          :allow-updating="true"
          :allow-adding="false"
          :use-icons="true"
          mode='popup'
        >
          <DxPopup
            :show-title="true"
            :width="700"
            :height="230"
            title="품목유형 변경"
          >
            <dx-position
              my="center"
              at="center"
              of="window"
            />
          </DxPopup>
          <DxForm>
            <DxItem
            :col-count="2"
            :col-span="2"
            item-type="group"
            >
              <DxItem data-field="품번"/>
              <DxItem data-field="품명"/>
              <DxItem data-field="품목유형"/>
               <DxItem data-field="도급"/>
              <DxItem data-field="사용유무"/>
              <DxItem data-field="삭제유무"/>

            </DxItem>
          </DxForm>
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          width="90"
          :buttons="editButtons"
          type="buttons"
        />
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :allowEditing='false'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          :visible='true'
          width="70"
        >
           <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='isIdEdit'
          :fixed="false"
          caption="품번"
          data-field="품번"
        >
            <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
          :visible='true'
        >
            <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
          sort-order='asc'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="구입가"
          data-field="구입가"
          :visible='false'
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="materialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="도급"
          data-field="도급"
          :visible='true'
        >
          <DxLookup
            :data-source="consignedLookup"
            display-expr="코드"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="도급/구매처"
          data-field="거래처명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption='구매/생산담당'
          data-field="담당부서"
          :visible='true'
          edit-cell-template="treeGridTemplate"
        >
          <DxLookup
            :data-source="divisionList"
            display-expr="부서명"
            value-expr="부서코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="투입인원"
          data-field="표준공수"
          :visible='false'
          format='#,##0.0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="규격"
          data-field="규격"
          :visible='false'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="단위"
          data-field="단위"
          :visible='true'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="주문/생산 Lot"
          data-field="주문lot"
          :visible='true'
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="삭제유무"
          data-field="삭제유무"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="등록일"
          data-field="createtime"
          dataType= 'date'
          format='yyyy-MM-dd'
          width = '100'>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :visible='true'
          caption="수정일"
          data-field="updatetime"
          dataType= 'date'
          format='yyyy-MM-dd'
          width = '100'>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="거래처코드"
          data-field="거래처코드"
          :visible='false'
        >
        </DxColumn>

        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import ExcelJS from 'exceljs'
import GoodsModel from '../../share/domain/GoodsModel'
import BomModel from '../../share/domain/BomModel'
import BomSemiModel from '../../share/domain/BomSemiModel'
import PressPriceModel from '../../share/domain/PressPriceModel'
import axios from 'axios'
import HttpService from '../../share/service/HttpService'

export default {
  name: 'login',
  props: {
  },
  data: function () {
    return {
      isLoading: false,
      editButtons: ['edit', 'delete'],
      rawMaterialInfoList: null,
      gridHeight: null,
      userInfo: null,
      selectedRow: null,
      itemTypeLookup: null,
      unitLookup: null,
      selectedCompanyCode: null,
      focusedRowKey: null,
      processingTypeLookup: null,
      productType: 'ALL',
      companyInfoList: [],
      isIdEdit: true,
      divisionList: null,
      carTypeLookup: null,
      consignedLookup: null,
      materialTypeLookup: null,
      // 품몰정보 저장 엑셀파일
      masCarModel: null,
      goodsInfoList: null,
      사급품List: null,
      productList: null,
      bomList: null,
      bomSemiList: null,
      pressPriceList: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxForm,
    DxItem,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxScrolling
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.carTypeLookup = this.$store.getters.getCarType
    this.consignedLookup = ConstDef.도급_LOOKUP
    this.refreshProduct(this.productType)
    this.MassCarModel()
    this.refreshCompany()
    this.refreshDivision()
    this.refresh사급품()
    // console.log('********** all product')
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onContentReady (e) {

    },
    onEditorPreparing (e) {
      if (e.dataField === '품번' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      // console.log(row)
      row.data.사용유무 = true
      row.data.삭제유무 = false
      row.data.품목유형 = this.productType // 구매품
    },
    onRowDbClick (row) {
      this.$refs.refRawMaterialGrid.instance.editRow(row.rowIndex)
    },
    async onRowRemoved (row) {
      this.isLoading = true
      await this.$_sp.runNoEncodeFindSqlProc('BOM차종', { 품번: row.data.품번 })
        .then(data => {
          if (this.$_sp.MakeModel(data).length > 0) {
            this.$snotify.error('양산 차종에 등록된 완제품 입니다')
            this.rawMaterialInfoList.push(row.data)
            this.$refs.refProductAllGrid.instance.refresh()
            this.focusedRowKey = row.data.품번
            this.isLoading = false
          }
        })
      if (this.isLoading === false) return
      await this.$_sp.runNoEncodeFindSqlProc('BOM정전개', { 품번: row.data.품번 })
        .then(data => {
          if (this.$_sp.MakeModel(data).length > 0) {
            this.$snotify.error('BOM 구성이 되어있는 제품 입니다.')
            this.rawMaterialInfoList.push(row.data)
            this.$refs.refProductAllGrid.instance.refresh()
            this.focusedRowKey = row.data.품번
            this.isLoading = false
          }
        })
      if (this.isLoading === false) return
      this.$_sp.runUpdateProc('spDeleteGoodsInfo', [{ 품번: row.data.품번 }])
        .then(data => {
          this.isLoading = false
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
      // console.log(row)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      row.data.거래처코드 = this.selectedCompanyCode

      if (row.data.품목유형 === ConstDef.구매품) {
        row.data.공정유형 = null
        row.data.표준공수 = null
      } else {
        row.data.구입가 = null
        row.data.거래처명 = null
        row.data.거래처코드 = null
        row.data.자재유형 = null
      }
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('품목정보', ['품번'], ['거래처명', '구입가'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            type: 'default',
            text: '품목엑셀등록',
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            type: 'default',
            text: 'BOM정전개',
            onClick: (args) => {
              this.onBomForwardRefresh()
            }
          }
        }
      )
    },
    refreshDivision () {
      this.$_sp.runNoEncodeFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_sp.MakeModel(data)
        })
    },
    refreshProduct (type) {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllProductByType', { 품목유형: type })
        .then((data) => {
          this.rawMaterialInfoList = this.$_sp.MakeModel(data)
          this.gridHeight = (screen.height - 250) * 0.95
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // emit compnay search
    setCompnayCode (code) {
      // console.log(code)
      this.selectedCompanyCode = code
    },
    // company info
    refreshCompany () {
      this.$_sp.runNoEncodeFindSqlProc('거래처정보', null)
        .then((data) => {
          this.companyInfoList = this.$_sp.MakeModel(data)
        })
    },
    // excel read
    refresh사급품 () {
      this.$_sp.runNoEncodeFindSqlProc('부자재정보', null)
        .then((data) => {
          this.사급품List = this.$_sp.MakeModel(data)
        })
    },
    MassCarModel () {
      this.$_sp.runNoEncodeFindSqlProc('고객사생산품목', { 사용유무: 1 })
        .then((data) => {
          this.masCarModel = this.$_sp.MakeModel(data)
        })
    },
    onDetailFileChange: function ($event) { // 중량 재업로드
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      const vm = this
      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          let array = []
          for (let j = 0; j < 4; j++) {
            let worksheet = workbook.worksheets[j]
            let row = null
            for (let i = 8; i < 500; i++) {
              let temp = {}
              row = worksheet.getRow(i)
              temp.품번 = `${AppLib.getCellFromExcel(row, 4)} : SHEET${j}`
              if (AppLib.getCellFromExcel(row, 4) === null) {
                console.log(`read row=${i - 3}`)
                break
              }
              temp.변경후단가 = AppLib.getCellFromExcelFormula(row, 8)
              temp.재로비 = AppLib.getCellFromExcelFormula(row, 11)
              temp.일반관리비 = AppLib.getCellFromExcelFormula(row, 13)
              temp.이윤 = AppLib.getCellFromExcelFormula(row, 14)
              temp.재료관리비 = AppLib.getCellFromExcelFormula(row, 15)
              temp.단가 = AppLib.getCellFromExcelFormula(row, 16)
              array.push(temp)
            }
          }
          console.log(array)
          vm.$_sp.runInsertOrUpdayeSqlProc('TEMP외주품구입가', ['품번'], null, array)
            .then((data) => {
              vm.$snotify.info('저장 완료')
            })
        })
      }
      reader.readAsArrayBuffer(file)
    },
    onDetailFileChangeWeight: function ($event) { // 중량 재업로드
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let vm = this
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          let array = []
          workbook.eachSheet(function (worksheet, sheetId) {
            vm.saveWeight(worksheet, array)
          })
          console.log(array)
          vm.$_sp.runUpdateSqlProc('TEMP', ['품번'], null, array)
            .then((data) => {
            })
        })
      }
      reader.readAsArrayBuffer(file)
    },
    saveWeight (worksheet, array) {
      if (worksheet.name !== 'MASTER' && worksheet.name.indexOf('Sheet') < 0) {
      // if (worksheet.name === '대우포승' && worksheet.name.indexOf('Sheet') < 0) {
        let row = null
        let value = null
        for (let i = 9; i < 3000; i++) {
          let dataJson = {}
          row = worksheet.getRow(i)
          value = AppLib.getCellFromExcel(row, 7)
          if (value === null) {
            console.log(`${worksheet.name}  read row=${i - 9}`)
            break
          }
          let raw = AppLib.getCellFromExcel(row, 10)
          if (raw === null) continue

          let w = AppLib.getCellFromExcel(row, 15)
          w = Math.round(w * 1000000) / 1000000

          // let n = AppLib.getCellFromExcel(row, 20)
          // let s = Math.round(AppLib.getCellFromExcel(row, 21) * 1000000) / 1000000
          // if (n === null) {
          //   s = Math.round(AppLib.getCellFromExcel(row, 21) * 1000000) / 1000000
          //   n = Math.round((w - s) * 100000) / 100000
          //   // console.log(value, w, n, s)
          // } else {
          //   s = w - n
          // }
          let 재료비 = AppLib.getCellFromExcelFormula(row, 19)
          // let SCRAP = AppLib.getCellFromExcelFormula(row, 23)
          if (재료비 !== null && 재료비.indexOf('ROUND') >= 0) {
            dataJson.품번 = value
            dataJson.재료비불량율 = 1.006
            array.push(dataJson)
          }
          // dataJson.scrap = SCRAP
        }
      }
    },
    onDetailFileChangeBom: function ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let vm = this
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      this.goodsInfoList = []
      this.productList = []
      this.pressPriceList = []
      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          const worksheet = workbook.worksheets[0]
          let row = worksheet.getRow(1)
          // eslint-disable-next-line no-unused-vars
          const motherCompany = vm.getCell(row, 1) // row.getCell(1).value
          let companyCode = vm.$_.findWhere(vm.companyInfoList, { 거래처명: motherCompany }).거래처코드
          let carType = null
          let productCode = null
          for (let i = 5; ; i++) {
            row = worksheet.getRow(i)
            carType = vm.getCell(row, 2) // row.getCell(2).value
            if (carType === null || carType.length === 0) {
              vm.buildBom()
              vm.insertGoods(companyCode)
              return
            }
            if (vm.$_.findIndex(vm.masCarModel, { 모델코드: carType }) >= 0) {
              if (vm.getCell(row, 3) === '●' || vm.getCell(row, 1) !== null) {
                productCode = vm.getCell(row, 6)
                vm.saveProduct(row, companyCode, motherCompany)
              } else {
                vm.saveSemi(row, companyCode, productCode)
              }
            }
          }
        })
      }
      reader.readAsArrayBuffer(file)
    },
    buildBom () {
      this.bomList = []
      this.bomSemiList = []
      let bom = null
      let bom1 = null
      let semi1 = null
      let child = null
      let where = null
      let beforeI = 0
      let i = 0
      // build bomList

      for (let i = 0; i < this.goodsInfoList.length; i++) {
        // console.log(this.goodsInfoList[i].parentId + ' index' + i)
      }

      for (let product of this.productList) {
        where = this.$_.where(this.goodsInfoList, { parentId: product.품번 })
        for (i = 0; i < where.length; i++) {
          if (where[i].품번 === '64816 L1000') {
            // console.log('64816 L1000')
          }
          if (where[i].품번 === where[i].parentId) {
            bom = new BomModel()
            bom.품번 = where[i].품번
            bom.품명 = where[i].품명
            bom.수량 = where[i].수량
            bom.상위품번 = null
            bom.최상위품번 = where[i].품번
            this.bomList.push(bom)
          } else {
            if (where[i].품번 === null) {
              // console.log('품번 null index = ' + i)
              // console.log(where[i])
            }
            if (where[i].품번.indexOf(':PW') >= 0) {
              bom1 = new BomModel()
              bom1.품번 = where[i].품번
              bom1.품명 = where[i].품명
              bom1.수량 = where[i].수량
              bom1.상위품번 = where[i].parentId
              bom1.최상위품번 = where[i].parentId
              this.bomList.push(bom1)
              // semi bom
              semi1 = new BomSemiModel()
              semi1.품번 = where[i].품번
              semi1.품명 = where[i].품명
              semi1.수량 = where[i].수량
              semi1.품목유형 = where[i].품목유형
              semi1.공정유형 = where[i].공정유형
              semi1.상위품번 = null
              semi1.최상위품번 = semi1.품번
              this.bomSemiList.push(semi1)
              i++
              beforeI = i
              let isPw프레스반제품 = false
              let indexPw프레스반제품 = 0
              for (; i < where.length; i++) {
                // console.log(where[i])
                if (i === beforeI) {
                  if (where[i].품목유형 === ConstDef.다공정품) {
                    isPw프레스반제품 = true
                    indexPw프레스반제품 = i
                  }
                }
                if (where[i].품번.indexOf(':BL') >= 0 || where[i].품번.indexOf(':SH') >= 0 || where[i].품번.indexOf(':C') >= 0) {
                  continue
                }
                if (i > beforeI && where[i].품명.indexOf('WELD-T NUT') < 0 &&
                                    where[i].품명.indexOf('WELD') < 1 &&
                                    where[i].품명.indexOf('도금너트') < 0 &&
                                    where[i].품명.indexOf('R-NUT') < 0 &&
                                    where[i].품명.indexOf('PIPE TRANSMISSION') < 0 &&
                                    where[i].품명.indexOf('도금 BOLT') < 0) {
                  i = i - 1
                  break
                }
                child = new BomSemiModel()
                child.품번 = where[i].품번
                child.품명 = where[i].품명
                child.수량 = where[i].수량
                child.품목유형 = where[i].품목유형
                child.공정유형 = where[i].공정유형
                child.상위품번 = semi1.품번
                child.최상위품번 = semi1.품번
                this.bomSemiList.push(child)
              }
              if (isPw프레스반제품) {
                for (let k = indexPw프레스반제품; k < where.length; k++) {
                  semi1 = new BomSemiModel()
                  semi1.품번 = where[k].품번
                  semi1.품명 = where[k].품명
                  semi1.수량 = where[k].수량
                  semi1.품목유형 = where[k].품목유형
                  semi1.공정유형 = where[k].공정유형
                  if (k === indexPw프레스반제품) {
                    semi1.상위품번 = null
                  } else {
                    semi1.상위품번 = where[k - 1].품번
                  }
                  semi1.최상위품번 = where[indexPw프레스반제품].품번
                  this.bomSemiList.push(semi1)
                  if (where[k].품번.indexOf(':C') >= 0) {
                    break
                  }
                }
              }
            } else if (where[i].품목유형 === ConstDef.다공정품) {
              bom1 = new BomModel()
              bom1.품번 = where[i].품번
              bom1.품명 = where[i].품명
              bom1.수량 = where[i].수량
              bom1.상위품번 = where[i].parentId
              bom1.최상위품번 = where[i].parentId
              this.bomList.push(bom1)

              semi1 = new BomSemiModel()
              semi1.품번 = where[i].품번
              semi1.품명 = where[i].품명
              semi1.수량 = where[i].수량
              semi1.품목유형 = where[i].품목유형
              semi1.공정유형 = where[i].공정유형
              semi1.상위품번 = null
              semi1.최상위품번 = where[i].품번
              this.bomSemiList.push(semi1)
              i++
              beforeI = i
              for (; i < where.length; i++) {
                child = new BomSemiModel()
                child.품번 = where[i].품번
                child.품명 = where[i].품명
                child.수량 = where[i].수량
                child.품목유형 = where[i].품목유형
                child.공정유형 = where[i].공정유형
                child.상위품번 = where[i - 1].품번
                child.최상위품번 = semi1.품번
                this.bomSemiList.push(child)
                if (where[i].품번.indexOf(':C') >= 0) {
                  break
                }
              }
            } else {
              bom1 = new BomModel()
              bom1.품번 = where[i].품번
              bom1.품명 = where[i].품명
              bom1.수량 = where[i].수량
              bom1.상위품번 = where[i].parentId
              bom1.최상위품번 = where[i].parentId
              this.bomList.push(bom1)
              /*
              if (where[i].자재유형 === ConstDef.외주품) {
                i++
              }
              */
            }
          }
        }
      }
      const bomProc = this.$_sp.runInsertOrUpdayeSqlProc('BOM정보', ['최상위품번', '품번'], null, this.bomList)
      const semiProc = this.$_sp.runInsertOrUpdayeSqlProc('BOM반제품', ['최상위품번', '품번'], null, this.bomSemiList)
      axios.all([bomProc, semiProc])
        .then(axios.spread((...reponse) => {
        }))
    },
    buildPressPrice (row) {
      let priceModel = new PressPriceModel()
      priceModel.품번 = this.getCell(row, 6)
      priceModel.cvt = parseInt(this.getCell(row, 13))
      priceModel.자사가로 = parseInt(this.getCell(row, 11))
      priceModel.자사세로 = parseInt(this.getCell(row, 12))
      priceModel.자사두께 = Math.round(parseFloat(this.getCell(row, 10)) * 10) / 10
      priceModel.자사중량 = Math.round(parseFloat(this.getCell(row, 14)) * 10000000) / 10000000 // this.getCell(row, 14)
      priceModel.자사net = Math.round(parseFloat(this.getCell(row, 19)) * 10000000) / 10000000
      priceModel.자사스크랩중량 = priceModel.자사중량 - priceModel.자사net
      this.pressPriceList.push(priceModel)
    },
    async insertGoods (companyCode) {
      const goods = this.$_sp.runInsertOrUpdayeSqlProc('품목정보', ['품번'], ['parentId', '수량'], this.goodsInfoList)
      const press = this.$_sp.runInsertOrUpdayeSqlProc('프레스재료비정보', ['품번'], null, this.pressPriceList)
      axios.all([goods, press])
        .then(axios.spread((...reponse) => {
          this.$snotify.info('저장 되었습니다.')
        }))
    },
    saveProduct (row, companyCode, companyName) {
      let model = new GoodsModel()

      model.차종 = this.getCell(row, 2)
      model.품번 = this.getCell(row, 6)
      model.납입품번 = model.품번
      model.품명 = this.getCell(row, 7)
      model.품목유형 = ConstDef.완제품
      if (model.품번 === '64842 C1000') {
        // console.log('64842 C1000')
      }
      if (this.getCell(row, 9) === null) { // 재질
        model.공정유형 = ConstDef.용접 // 'B0205'
      } else {
        model.공정유형 = ConstDef.프레싱 // 'B0202'
      }
      if (this.getCell(row, 3) === 'PR') { // 프레스공정
        if (this.getCell(row, 28) === '오토') {
          if (this.getCell(row, 29) === null) {
            console.log(model)
          }
          if (this.getCell(row, 29).toUpperCase().indexOf('PRO') >= 0) {
            model.공정유형 = ConstDef.프로그레시브
          }
        } else {
          model.품목유형 = ConstDef.구매품 // 'S0106'
          model.자재유형 = ConstDef.외주직납품 // 'S0409'
          model.거래처코드 = this.$_.findWhere(this.companyInfoList, { 거래처명: this.getCell(row, 28) }).거래처코드
        }
      }
      model.주문lot = 1
      model.단위 = 'B1101'
      model.구매단위 = 'B1101'
      model.변환배율 = 1.0
      model.납품처코드 = companyCode
      model.납품장소 = companyName
      model.재질 = this.getCell(row, 9)
      model.수량 = 1
      model.parentId = model.품번
      this.productList.push(model)
      this.goodsInfoList.push(model)
      if (model.자재유형 !== ConstDef.외주직납품 && (model.공정유형 === ConstDef.프레싱 || model.공정유형 === ConstDef.프로그레시브)) { // 소재추가
        // 중간다공정
        if (model.공정유형 === ConstDef.프레싱) {
          let processing = new GoodsModel()
          if (this.getCell(row, 29).toUpperCase().indexOf('DR') >= 0 || this.getCell(row, 29).toUpperCase().indexOf('SH') >= 0) {
            processing.품번 = model.품번 + 'SH'
            processing.공정유형 = ConstDef.샤링
          } else if (this.getCell(row, 29).toUpperCase().indexOf('BL') >= 0) {
            processing.품번 = model.품번 + 'BL'
            processing.공정유형 = ConstDef.블랭킹
          }
          processing.품명 = model.품명
          processing.납입품번 = processing.품번
          processing.품목유형 = ConstDef.다공정품
          processing.주문lot = 1
          processing.단위 = 'B1101'
          processing.구매단위 = 'B1101'
          processing.변환배율 = 1.0
          processing.수량 = 1
          processing.parentId = model.품번
          this.goodsInfoList.push(processing)
        }

        let coil = new GoodsModel()
        coil.품번 = model.품번 + ':C'
        coil.품명 = model.품명
        coil.납입품번 = model.품번 + ':C'
        coil.품목유형 = ConstDef.구매품
        coil.자재유형 = ConstDef.자재유형_원자재
        coil.주문lot = 1
        coil.단위 = 'B1102'
        coil.구매단위 = 'B1102'
        coil.변환배율 = 1.0
        coil.재질 = model.재질
        coil.거래처코드 = companyCode
        coil.수량 = Math.round(parseFloat(this.getCell(row, 14)) * 10000) / 10000
        coil.parentId = model.품번
        this.goodsInfoList.push(coil)
        this.buildPressPrice(row)
      }
      if (model.자재유형 === ConstDef.외주직납품) { // 소재추가
        let coil = new GoodsModel()
        coil.품번 = model.품번 + ':C'
        coil.품명 = model.품명
        coil.납입품번 = model.품번 + ':C'
        coil.품목유형 = ConstDef.구매품
        coil.자재유형 = ConstDef.자재유형_원자재
        coil.주문lot = 1
        coil.단위 = 'B1102'
        coil.구매단위 = 'B1102'
        coil.변환배율 = 1.0
        coil.재질 = model.재질
        coil.거래처코드 = companyCode
        coil.수량 = Math.round(parseFloat(this.getCell(row, 14)) * 10000) / 10000
        coil.parentId = model.품번
        this.goodsInfoList.push(coil)
        this.buildPressPrice(row)
      }
    },
    saveSemi (row, motherCompanyCode, productNo) {
      let where = null
      let model = new GoodsModel()

      if (this.getCell(row, 4) === 'PW') { // 용접반제품
        let pwModel = new GoodsModel()
        pwModel.품번 = this.getCell(row, 6) + ':PW'
        pwModel.납입품번 = pwModel.품번
        pwModel.품명 = this.getCell(row, 7) + '(PW)'
        pwModel.품목유형 = ConstDef.반제품 // 'S0102'
        pwModel.공정유형 = ConstDef.프로젝션 //  'B0204'
        pwModel.주문lot = 1
        pwModel.단위 = 'B1101'
        pwModel.구매단위 = 'B1101'
        pwModel.변환배율 = 1.0
        pwModel.도급 = '자작'
        // parent id assign
        pwModel.수량 = parseInt(this.getCell(row, 8))
        pwModel.parentId = productNo
        this.goodsInfoList.push(pwModel)
      }

      if (this.getCell(row, 28) === 'JS' || this.getCell(row, 28) === '정인') {
        // console.log('도급반제품' + this.getCell(row, 6))
        if (this.getCell(row, 28) === '정인') {
          where = this.$_.findWhere(this.goodsInfoList, { 품번: `${this.getCell(row, 6)}:PW` })
          if (where === undefined) {
            where = this.$_.findWhere(this.goodsInfoList, { 품번: this.getCell(row, 6) })
          }
        } else {
          where = this.$_.findWhere(this.goodsInfoList, { 품번: this.getCell(row, 6) })
        }
        if (where === undefined) {
          console.log('not found 도급 품번' + this.getCell(row, 6))
        } else {
          where.도급 = '도급'
          where.거래처코드 = this.$_.findWhere(this.companyInfoList, { 거래처명: this.getCell(row, 28) }).거래처코드
          where.외주가공비 = this.getCell(row, 27)
        }
      } else {
        model.품번 = this.getCell(row, 6)
        model.납입품번 = model.품번
        model.품명 = this.getCell(row, 7)
        if (this.getCell(row, 3) === 'HW') { // 구매품
          model.품목유형 = ConstDef.구매품
          model.자재유형 = ConstDef.부자재
          let code = this.getCell(row, 28) === null ? '에스탑' : this.getCell(row, 28)
          if (this.$_.findWhere(this.companyInfoList, { 거래처명: code }) === undefined) {
            console.log(model)
          }
          model.거래처코드 = this.$_.findWhere(this.companyInfoList, { 거래처명: code }).거래처코드
          let index = this.$_.findIndex(this.사급품List, { 부번: model.품번 })
          if (model.품번.indexOf(':FP') >= 0) { // 도장
            model.외주가공비 = this.getCell(row, 27)
          }
          // // console.log('index = ' + index + model.품번)
          if (index >= 0) {
            if (this.사급품List[index].구분 === '사급부품') {
              model.자재유형 = ConstDef.사급품
            }
            let code = this.getCell(row, 28) === null ? '에스탑' : this.getCell(row, 28)
            model.거래처코드 = this.$_.findWhere(this.companyInfoList, { 거래처명: code }).거래처코드
          }
        } else if (this.getCell(row, 3) === 'PR') {
          if (this.getCell(row, 28) === '오토') {
            model.품목유형 = ConstDef.다공정품
            model.공정유형 = ConstDef.프레싱 // 'B0202'
            if (this.getCell(row, 29) === 'PROG') {
              // console.log('PROGRESSIVE')
              // console.log(model)
              model.공정유형 = ConstDef.프로그레시브
            }
          } else {
            model.품목유형 = ConstDef.구매품
            model.공정유형 = ConstDef.프레싱
            model.자재유형 = ConstDef.외주품
            let code = this.getCell(row, 28)
            model.거래처코드 = this.$_.findWhere(this.companyInfoList, { 거래처명: code }).거래처코드
          }
        }
        model.주문lot = 1
        model.단위 = 'B1101'
        model.구매단위 = 'B1101'
        model.변환배율 = 1.0
        model.재질 = this.getCell(row, 9)
        model.수량 = parseInt(this.getCell(row, 8))
        // parent id assign
        model.parentId = productNo
        this.goodsInfoList.push(model)
        // 소재추가
        if (model.공정유형 === ConstDef.프레싱 || model.공정유형 === ConstDef.프로그레시브) { // 소재추가
          // 중간다공정
          if (model.품목유형 === ConstDef.다공정품 && model.공정유형 === ConstDef.프레싱) {
            let processing = new GoodsModel()
            if (this.getCell(row, 29).toUpperCase().indexOf('DR') >= 0 || this.getCell(row, 29).toUpperCase().indexOf('SH') >= 0) {
              processing.품번 = model.품번 + ':SH'
              processing.공정유형 = ConstDef.샤링
            } else if (this.getCell(row, 29).toUpperCase().indexOf('BL') >= 0) {
              processing.품번 = model.품번 + ':BL'
              processing.공정유형 = ConstDef.블랭킹
            }
            processing.품명 = model.품명
            processing.납입품번 = processing.품번
            processing.품목유형 = ConstDef.다공정품
            processing.주문lot = 1
            processing.단위 = 'B1101'
            processing.구매단위 = 'B1101'
            processing.변환배율 = 1.0
            processing.parentId = productNo
            processing.수량 = model.수량
            this.goodsInfoList.push(processing)
          }

          // 철판 원자재
          let coil = new GoodsModel()
          coil.품번 = model.품번 + ':C'
          coil.품명 = model.품명
          coil.납입품번 = model.품번 + ':C'
          coil.품목유형 = ConstDef.구매품
          coil.자재유형 = ConstDef.자재유형_원자재
          coil.주문lot = 1
          coil.단위 = 'B1102'
          coil.구매단위 = 'B1102'
          coil.변환배율 = 1.0
          coil.재질 = model.재질
          coil.거래처코드 = motherCompanyCode
          coil.수량 = Math.round(parseFloat(this.getCell(row, 14)) * 10000) / 10000
          // parent id assign
          coil.parentId = productNo
          this.goodsInfoList.push(coil)
          this.buildPressPrice(row)
        }
      }
    },
    getCell (row, index) {
      let result = row.getCell(index).value
      if (result !== null) {
        result = `${result}`.trim()
        if (result.length === 0) {
          result = null
        }
      }
      return result
    },
    async onBomForwardRefresh () {
      await this.$_sp.runDeleteSqlProc('BOM정전개', [{ title: 'bomForward' }])
        .then((data) => {
        })
      this.isLoading = true
      HttpService.reqPost({}, '/forwardBomAll')
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('정전개 완료 되었습니다.')
        })
    }
  }
}
</script>

<style lang="scss">
.ff{
  text-align: center;
}
</style>
